import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Top from '../views/Top.vue'
import ItemSize from '../views/ItemSize.vue'
import ItemPage from '../views/ItemPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/top',
    name: 'Top',
    component: Top
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/item-page/:id',
    component: ItemPage,
    props: true
  },
  {
    path: '/item-size/:id',
    name: 'ItemSize',
    component: ItemSize
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
